import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoginPageErrorsState {
    message: string;
}

const initialState: LoginPageErrorsState = {
    message: '',
};

const loginPageErrors = createSlice({
    name: 'login/errors',
    initialState: initialState,
    reducers: {
        setLoginPageError: (state, action: PayloadAction<string>) => {
            return { ...state, message: action.payload };
        },
        clearLoginPageError: state => {
            return { ...state, message: '' };
        },
    },
});

export const { setLoginPageError, clearLoginPageError } =
    loginPageErrors.actions;
export const loginPageErrorsReducer = loginPageErrors.reducer;
export const selectLoginPageError = (state: {
    loginPageErrors: LoginPageErrorsState;
}) => state.loginPageErrors.message;
